module.exports = __webpack_public_path__ + "img/avatar-room.de3b5fcd.svg";